import React, { FC } from 'react';
import { Spacing, Table, useScopedSelector, Visible } from 'ia-react-core';
import { SecuredMessagingState } from '../../../../../interfaces/SecuredMessagingState';
import MessagesRows from './MessagesRows';
import MessagesRowsPhone from './MessagesRowsPhone';
import MessagesTableHeader from './MessagesTableHeader';

export interface MessagesProps {
  sentMessages: boolean;
}

const Messages: FC<MessagesProps> = ({ sentMessages }) => {
  const messages = useScopedSelector((state: SecuredMessagingState) => state.messages?.data);

  return (
    <>
      <Visible sm md lg xl xxl>
        <Table>
          <MessagesTableHeader sentMessages={sentMessages} />
          {messages ? messages.map((message) => (<MessagesRows key={`MessageRow${message.id}`} message={message} />)) : null}
        </Table>
      </Visible>
      {messages ?
        <Visible xs>
          <Spacing m-h={-16}>
            {messages.map((message) => (<MessagesRowsPhone key={`MessageRow${message.id}`} message={message} />))}
          </Spacing>
        </Visible>
        : null}
    </>
  );
};
export default Messages;
